import { useParams } from 'react-router-dom';

import { useQuery, gql } from '@zenbusiness/application-commons-graphql';

import { groupByBundles } from '../utils/orders';

const GET_ORDER_VIEW_QUERY = gql`
  query GetOrderView($businessEntityUuid: UUID!) {
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      name
      type
    }
    accountInfo {
      accountUuid
      accountEmail
      firstName
      lastName
      orders(businessEntityUuid: $businessEntityUuid) {
        orderUuid
        purchaseDate
        status
        orderTasksLegacy {
          orderTaskUuid
          orderTaskType
          orderTaskStatus
          createdDatetime
          updatedDatetime
          jurisdiction
          orderTaskJurisdiction
          orderItemUuid
          termEndDate
          displayName
          isCora
          orderTaskData {
            ... on PlanData {
              addons
            }
            ... on EmailData {
              emailAddress
              fullEmailAddress
            }
            ... on FutureFileData {
              futureFilingDate
            }
            ... on LLCFormationData {
              estimatedFormationDate
              name
              alternates
              domesticJurisdiction
              physicalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              mailingAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              principalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              purpose
              managerType
              members {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              managers {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              registeredAgent {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              contact {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
            }
            ... on CorpFormationData {
              estimatedFormationDate
              name
              alternates
              domesticJurisdiction
              physicalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              mailingAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              principalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              purpose
              authorizedShares
              parValue
              directors {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              officers {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              registeredAgent {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              contact {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
            }
            ... on EntityNameData {
              name
              jurisdiction
            }
            ... on DomainNameData {
              skip
              primary
            }
            ... on AnnualReportData {
              jurisdiction
            }
            ... on AmendmentData {
              amendmentDescription
            }
            ... on GoodStandingData {
              jurisdiction
            }
            ... on WFGData {
              name
              type
              domesticJurisdiction
              physicalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              mailingAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              principalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              purpose
              managerType
              managers {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              members {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              directors {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              officers {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              registeredAgent {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              contact {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
            }
            ... on RegisteredAgentServiceData {
              name
              alternates
              domesticJurisdiction
              isCora
              physicalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              mailingAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              principalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              purpose
              managerType
              members {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              managers {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              registeredAgent {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
              contact {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
              }
            }
            ... on EINData {
              standalone
              name
              type
              jurisdiction
              physicalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              mailingAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              principalAddress {
                address1
                address2
                city
                state
                zip
                county
                country
                mailboxIdentifier
              }
              reason
              activity1
              activity2
              activity3
              activity4
              activity5
              activitySpecify
              taxedAsSingleMemberLLC
              taxedAsSCorp
              memberCount
              responsibleParty {
                contactUuid
                companyName
                firstName
                middleName
                lastName
                suffix
                address1
                address2
                city
                state
                zip
                phone
                email
                legalName
                ein
                previousEin
                alternateLastNames
                hasSsn
                collectDataFromUser
              }
              corpCareOf
              corpClosingMonth
              startDate
              gambling
              atf
              employeesWithW2
              w2WagesPaidDate
              w2AgriculturalEmployeesCount
              w2OtherEmployeesCount
              w2Wageslt1000
              highwayVehicle
              highwayVehicleOver55000
              filesForm720
              tradeNames
            }
          }
        }
      }
    }
    transactionItems(businessEntityUuid: $businessEntityUuid) {
      orderBillingUuid
      orderItemUuid
      description
      type
      amount
      cardType
      cardLastFour
      transactionDatetime
    }
  }
`;

const GET_STOCK_SETUP_QUERY = gql`
  query GetStockSetup($orderTaskUuid: UUID!) {
    stockSetup(orderTaskUuid: $orderTaskUuid) {
      corpStockInformationUuid
      orderTaskUuid
      stockTotal
      stockTotalAdjusted
      shareQty
      parValue
      fees {
        expediteFee {
          feeType
          feeAmount
          feeAmountAdjusted
        }
        stateDocumentFee {
          feeType
          feeAmount
          feeAmountAdjusted
        }
        stateProcessingFee {
          feeType
          feeAmount
          feeAmountAdjusted
        }
        stateStockFee {
          feeType
          feeAmount
          feeAmountAdjusted
        }
      }
    }
  }
`;

const GET_FORMATION_TIMELINE_QUERY = gql`
  query GetFormationTimeline($businessEntityUuid: UUID!) {
    timeline(businessEntityUuid: $businessEntityUuid) {
      date
      events {
        topic
        date
        status
      }
    }
  }
`;

const GET_BUNDLE_QUERY = gql`
  query GetBundle($serviceId: String!) {
    bundle(serviceId: $serviceId) {
      contents {
        service
      }
      relatedPlanPricing {
        service
      }
    }
  }
`;

const useOrderView = () => {
  const { businessEntityUuid, orderTaskUuid } = useParams();

  // Main data query
  const {
    data: orderData,
    loading: orderLoading,
    error: orderError
  } = useQuery(GET_ORDER_VIEW_QUERY, {
    variables: { businessEntityUuid }
  });

  // Extract data from main query
  const businessEntity = orderData?.businessEntity || {};
  const accountInfo = orderData?.accountInfo || {};
  const transactionItems = orderData?.transactionItems || [];

  // Flatten orderTasks from nested orders structure
  const orderTasks = accountInfo?.orders?.reduce(
    (acc, order) => [...acc, ...(order.orderTasksLegacy || [])],
    []
  ) || [];

  // Find the current order task
  const currentOrderTask = orderTasks.find(
    (task) => task.orderTaskUuid === orderTaskUuid
  );

  // Detect plan/bundle type
  const isPlanType = currentOrderTask?.orderTaskType?.includes('_plan_');

  // Bundle query — only run if we have a current order task
  const {
    data: bundleData,
    loading: bundleLoading
  } = useQuery(GET_BUNDLE_QUERY, {
    variables: { serviceId: currentOrderTask?.orderTaskType || '' },
    skip: !currentOrderTask
  });

  const bundlesData = bundleData?.bundle || [];
  const bundlesServices = new Set(
    bundlesData.map(({ relatedPlanPricing }) => relatedPlanPricing?.service)
  );
  const isBundle = bundlesServices.has(currentOrderTask?.orderTaskType);
  const isPlan = isPlanType || isBundle;

  // Group tasks by bundles if plan/bundle
  let groupedOrderTasks = orderTasks;
  if (isPlan && bundlesData.length > 0) {
    const grouped = groupByBundles(orderTasks, bundlesData);
    const currentGroup = grouped.find(
      (g) => g.task.orderTaskUuid === orderTaskUuid
    );
    if (currentGroup) {
      groupedOrderTasks = [currentGroup.task, ...currentGroup.subtasks];
    }
  }

  // Stock setup — only for corp formation
  const isCorpFormation = currentOrderTask?.orderTaskType === 'corp_formation';
  const {
    data: stockData
  } = useQuery(GET_STOCK_SETUP_QUERY, {
    variables: { orderTaskUuid: orderTaskUuid || '' },
    skip: !isCorpFormation
  });

  // Formation timeline
  const {
    data: timelineData
  } = useQuery(GET_FORMATION_TIMELINE_QUERY, {
    variables: { businessEntityUuid },
    skip: !businessEntityUuid
  });

  const timeline = timelineData?.timeline || [];

  const loading = orderLoading || bundleLoading;

  return {
    loading,
    error: orderError,
    businessEntity: {
      businessEntityName: businessEntity.name,
      businessEntityType: businessEntity.type,
      businessEntityUuid: businessEntity.uuid
    },
    account: {
      accountEmail: accountInfo.accountEmail,
      firstName: accountInfo.firstName,
      lastName: accountInfo.lastName
    },
    orderTasks: groupedOrderTasks,
    currentOrderTask,
    transactionItems,
    stockSetupData: stockData?.stockSetup || {},
    timeline,
    isPlan,
    isBundle
  };
};

export default useOrderView;
